import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

export default function Header() {
  const [selectedMenu, setSelectedMenu] = useState("Blockchain & DeFi");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const timeoutRef = useRef(null);

  const toggleDropdown = (e) => {
    if (e) e.preventDefault();
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsDropdownOpen(false);
    }, 250);
  };

  const menuItems = [
    {
      name: "Blockchain & DeFi",
      path: "/blockchain-consulting",
      content:
        "Build secure and scalable blockchain solutions with decentralized finance, smart contracts, tokenization, and Web3 technologies designed for the future of digital finance.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Artificial Intelligence",
      content:
        "Leverage AI-powered solutions to automate processes, analyze data, improve decision-making, and create intelligent digital experiences that drive business growth.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Gaming",
      content:
        "Create next-generation gaming experiences with blockchain, digital assets, Web3 mechanics, and immersive technologies that connect players with new digital economies.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Web3 & Metaverse",
      content:
        "Develop immersive Web3 and Metaverse experiences that combine decentralized technologies, digital ownership, virtual environments, and connected communities.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Marketing",
      content:
        "Grow your Web3 and blockchain brand with strategic digital marketing, community building, content creation, and campaigns designed to reach the right audience.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Exchange",
      content:
        "Build powerful and secure crypto exchange platforms with seamless trading experiences, advanced functionality, liquidity solutions, and user-focused interfaces.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    {
      name: "Trading Bot",
      content:
        "Automate crypto trading with intelligent trading bots designed to execute strategies efficiently, monitor markets, and help traders respond to changing market conditions.",
      img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    },
    // {
    //   name: "MLM Solutions",
    //   path: "/decentralised-mlm-plan-developer",
    //   content:
    //     "Design and develop decentralized MLM platforms with smart contract automation (matrix, binary, and hybrid plans) for secure, transparent, and instant reward distribution.",
    //   img: "assets/img/639b830a4cbdd20fd5f3a9a9/63a6a2459e8536a2c0b517e1_blockchain-mege-img@2x.png",
    // },
  ];

  return (
    <>
      <div className="nav_bg">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light py-3 justify-content-between w-100">
            <div className="d-flex justify-content-between w-100 toggle">
              <Link className="navbar-brand text-white" to="/">
                <img src="assets/logo/Light@2x.png" alt="" className="header-logo" />
              </Link>
              <button
                className="navbar-toggler toggle_btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/header_toggle.svg"
                  alt=""
                />
              </button>
            </div>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0 d-flex gap-3 font_14 fw-bold pe-lg-3 pe-0">
                <li className="nav-item nav_menu_padding">
                  <Link
                    className="nav-link nav_menu active text-white ps-lg-0 ps-4"
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item nav_menu_padding">
                  <Link
                    className="nav-link nav_menu text-white ps-lg-0 ps-4"
                    to="/about"
                  >
                    About
                  </Link>
                </li>
                <li
                  className="nav-item dropdown nav_menu_padding"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <a
                    className="nav-link dropdown-toggle nav_menu text-white ps-lg-0 ps-4"
                    href="#"
                    onClick={toggleDropdown}
                  >
                    Services
                  </a>
                  <div
                    className={`dropdown-menu sub_menus menu_width ${isDropdownOpen ? "d-block" : "d-none"
                      }`}
                  >
                    <div className="d-flex">
                      <div className="side_menu col-lg-4">
                        {menuItems.map((item) => (
                          <div
                            className="d-flex justify-content-between nav-services"
                            onClick={() => setSelectedMenu(item.name)}
                          >
                            <a
                              key={item.name}
                              className={`dropdown-item nav_menu mb-2 p-0 font_14 ${selectedMenu === item.name ? "active" : ""
                                }`}
                              href="#"
                            >
                              {item.name}
                            </a>
                            <img
                              src="assets/img/639b830a4cbdd20fd5f3a9a9/right-arrow.svg"
                              alt=""
                              className="d-lg-block d-none"
                            />
                          </div>
                        ))}
                      </div>
                      <div className="dropdown-content col-lg-8 ms-4 d-lg-flex d-md-none align-items-start ps-0">
                        <div className="w-50">
                          <h6 className="fw-bold font-12">{selectedMenu}</h6>
                          <p className="font_14 fw-normal">
                            {
                              menuItems.find(
                                (item) => item.name === selectedMenu
                              )?.content
                            }
                          </p>
                          {menuItems.find((item) => item.name === selectedMenu)?.path && (
                            <Link
                              to={menuItems.find((item) => item.name === selectedMenu)?.path}
                              className="text-decoration-none font_14 fw-bold mt-2 d-inline-block"
                              style={{
                                background: "linear-gradient(135deg, #00d2ff 0%, #0072ff 100%)",
                                fontWeight: 600,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                                color: "transparent",
                              }}
                            >
                              Explore Service →
                            </Link>
                          )}
                        </div>
                        <img
                          src={
                            menuItems.find((item) => item.name === selectedMenu)
                              ?.img
                          }
                          alt={selectedMenu}
                          className="ms-3 img-fluid"
                          style={{ maxWidth: "150px", height: "auto" }}
                        />
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item nav_menu_padding">
                  <Link
                    className="nav-link nav_menu text-white ps-lg-0 ps-4"
                    to="/blockchain-consulting"
                  >
                    Consulting
                  </Link>
                </li>
                <li className="nav-item nav_menu_padding">
                  <a className="nav-link nav_menu text-white ps-lg-0 ps-4" href="/">
                    Blockchain
                  </a>
                </li>
              </ul>
            </div>
            <form className="d-lg-flex d-none">
              <Link to="/contact" className="btn genxmeta_button hero_btn font_14 fw-bold">
                Contact
              </Link>
            </form>
          </nav>
        </div>
      </div>
    </>
  );
}
